<template>
<div class="chapter">
<div class="inner_page">
<div class="ded">
<p class="center1"><em>To admirable Erin, intrepid Desmond,<br/> and the noble, newborn Victor:<br/> our future together is grand.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?a0a49e94